import { Component, computed, HostBinding, inject, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HlmErrorDirective, HlmFormFieldComponent, HlmHintDirective } from '@spartan-ng/ui-formfield-helm';
import { HlmLabelDirective } from '@spartan-ng/ui-label-helm';
import { BrnSelectComponent, BrnSelectContentComponent, BrnSelectValueComponent } from '@spartan-ng/brain/select';
import { HlmSelectContentDirective, HlmSelectModule, HlmSelectValueDirective } from '@spartan-ng/ui-select-helm';

@Component({
  selector: 'app-spartan-select',
  imports: [
    FormsModule,
    HlmErrorDirective,
    HlmFormFieldComponent,
    HlmHintDirective,
    HlmLabelDirective,
    BrnSelectComponent,
    BrnSelectContentComponent,
    BrnSelectValueComponent,
    HlmSelectContentDirective,
    HlmSelectModule,
    HlmSelectValueDirective,
    ReactiveFormsModule,
  ],
  standalone: true,
  templateUrl: './spartan-select.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true, optional: true }),
    },
  ],
})
export class SpartanSelectComponent {
  @HostBinding('class') class = 'block';

  @Input() placeholder: string;
  @Input() control: string;
  @Input() label: string;
  @Input() hint: string;
  @Input() options: any[];

  private readonly parentContainer = inject(ControlContainer);

  get parentFormGroup() {
    return this.parentContainer.control as FormGroup;
  }

  protected required = computed(() => this.formControl.hasValidator(Validators.required));

  ngOnInit(): void {
    this.parentFormGroup.addControl(this.control, new FormControl(null), { emitEvent: false });
  }

  get formControl() {
    return this.parentFormGroup.get(this.control) as FormControl;
  }

  ngOnDestroy(): void {
    this.parentFormGroup.removeControl(this.control);
  }
}
